import { uniq as _uniq } from "@tldraw/utils";
function uniq(array) {
  return _uniq(array);
}
export {
  uniq
};
//# sourceMappingURL=uniq.mjs.map
